module.exports = __webpack_public_path__ + "img/92178.ed38f71f.svg";